<div #track class="slide-to-confirm-track">
  <div class="slide-to-confirm-label">Slide to confirm</div>
  <div
    class="slide-to-confirm-fill"
    [style.width]="fillWidthStyle"
  ></div>
  <div
    class="slide-to-confirm-handle"
    [style.left]="thumbLeftStyle"
    [class.confirmed]="isConfirmed"
    (pointerdown)="onHandlePointerDown($event)"
  ></div>
</div>
